import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { Observable, of, EMPTY } from "rxjs";

import { LoadingDialogService } from "@shared/services/loading-dialog/loading-dialog.service";
import { AnalyticsService } from "@shared/services/analytics/analytics.service";

@Injectable({
  providedIn: "root",
})
export class UserResolver {
  private router = inject(Router);

  private loadingDialogService = inject(LoadingDialogService);

  private analyticsService = inject(AnalyticsService);

  resolve(route: ActivatedRouteSnapshot): Observable<unknown> {
    this.loadingDialogService.show();

    const navigationUser = this.router.getCurrentNavigation()?.extras.state as
      { user?: unknown } | undefined;

    const stateUser = navigationUser?.user;

    if (stateUser) {
      this.analyticsService.user.next((stateUser as any)?.data?.customer);
      this.loadingDialogService.close();
      return of(stateUser);
    }

    const id = route.parent?.paramMap.get("id") ?? route.paramMap.get("id");
    this.loadingDialogService.close();
    void this.router.navigate(["/renovacao", id ?? ""]);
    return EMPTY;
  }
}
